import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import LoadingIndicator from './LoadingIndicator'

function WaitFor({ action, dispatch, children, throwOnError }) {
  const [resolution, setResolution] = useState({
    resolved: false,
    result: null,
    error: null
  })
  const dispatchIt = useDispatch()

  useEffect(() => {
    let theAction = action

    if (dispatch) {
      theAction = () => dispatchIt(dispatch)
    }

    theAction()
      .then(result => {
        //console.log("Action", theAction, "resolved with", result)
        setResolution({
          resolved: true,
          result,
          error: null
        })
      })
      .catch(error => {
        setResolution({
          resolved: true,
          error,
          result: null
        })
      })
  }, [])
  const { resolved, result, error } = resolution

  if (error && throwOnError) {
    console.error(error, 'occurred during WaitFor')
    //Trigger sentry
    throw error
  } else if (resolved) {
    //If children is a function, pass it the resolution
    if (children && typeof children === 'function') {
      return children(resolution)
    }

    return children
  } else {
    return <LoadingIndicator newSiteLook={true} />
  }
}

WaitFor.propTypes = {}
WaitFor.defaultProps = {
  throwOnError: true
}

export default WaitFor
